module.exports = __webpack_public_path__ + "img/badge-ggl-play.55268d57.png";